import React from 'react';
import { Segment, Form } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import { filter, clone } from 'ramda';


const TableHeader = (props) => {
  const {
    events = [],
    competitions = [],
    t
  } = props;

  const lang = i18next.language;
  const translatedCompetitions = clone(competitions).map(c => {
    c.text = c.text[lang];
    return c;
  });

  return (
    <div>
      <Segment basic>
        <Form>
          <Form.Group>
            <Form.Dropdown
              label={t('my:competitors.header.event')}
              placeholder={t('my:competitors.header.event_i')}
              selection
              options={filter(e => e.type === 'COMPETITION', events)}
              onChange={props.onSelectEvent}
            />
            &nbsp;
            <Form.Dropdown
              label={t('my:competitors.header.competition')}
              placeholder={t('my:competitors.header.competition_i')}
              selection
              options={translatedCompetitions}
              onChange={props.onSelectCompetition}
            />
          </Form.Group>
        </Form>
      </Segment>
    </div>
  );
};

export default withNamespaces('my')(TableHeader);



// WEBPACK FOOTER //
// ./src/private/user/components/Competitors/Header.js